// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"041b4501","394":"96c48af4"}[chunkId] + ".chunk.css";
};